import { cn } from '@/lib/utils'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]',
}

export function LoadingSpinner({ size = 'md', className }: Props) {
  return (
    <div
      role="status"
      aria-label="Caricamento..."
      className={cn(
        'animate-spin rounded-full border-holly-200 border-t-holly-600',
        sizes[size],
        className
      )}
    />
  )
}
